/**
 * Macro Channels Configuration
 * 
 * Defines the available channels for macro functionality.
 * Used across macro starting point, response blocks, and other macro-related components.
 */

export enum MacroChannelKey {
  WHATSAPP = "whatsapp",
  EMAIL = "email",
  INSTAGRAM = "instagram",
  MESSENGER = "messenger",
  LIVECHAT = "livechat",
}

export interface MacroChannel {
  key: MacroChannelKey;
  label: string;
}

export const MACRO_CHANNELS: MacroChannel[] = [
  { key: MacroChannelKey.WHATSAPP, label: "WhatsApp" },
  { key: MacroChannelKey.EMAIL, label: "Email" },
  { key: MacroChannelKey.INSTAGRAM, label: "Instagram" },
  { key: MacroChannelKey.MESSENGER, label: "Facebook" },
  { key: MacroChannelKey.LIVECHAT, label: "Live chat" },
];

/**
 * Helper function to get macro channel label by key
 */
export const getMacroChannelLabel = (key: MacroChannelKey | string): string => {
  const channel = MACRO_CHANNELS.find((ch) => ch.key === key);
  return channel?.label || key;
};
